<template>
  <div class="container text-start">
    <div class="row align-items-start">
      <div class="col-12 my-3">
        <h4 class="text-start">Add New User</h4>
      </div>
    </div>

    <div v-if="error" class="container text-danger fw-bold text-start my-1">
      {{ error }}
      <button
        type="button"
        class="btn-close btn-danger pt-0"
        @click="error = null"
      />
    </div>

    <form @submit.prevent="createUserRequest">
      <div class="mb-3 col-3">
        <label for="exampleInputEmail1" class="form-label fw-bold">Email</label>
        <input
          id="exampleInputEmail1"
          v-model="email"
          type="email"
          class="form-control"
          aria-describedby="emailHelp"
          placeholder="Email"
          required
        />
      </div>
      <div class="mb-3 col-3">
        <label for="exampleInputEmail1" class="form-label fw-bold"
          >First Name</label
        >
        <input
          id="exampleInputEmail1"
          v-model="firstName"
          type="text"
          class="form-control"
          aria-describedby="emailHelp"
          placeholder="First Name"
          required
        />
      </div>
      <div class="mb-3 col-3">
        <label for="exampleInputEmail1" class="form-label fw-bold"
          >Last Name</label
        >
        <input
          id="exampleInputEmail1"
          v-model="lastName"
          type="text"
          class="form-control"
          aria-describedby="emailHelp"
          placeholder="Last Name"
          required
        />
      </div>
      <div class="mb-3 col-3">
        <label for="exampleInputPassword1" class="form-label fw-bold"
          >Password</label
        >
        <input
          id="exampleInputPassword1"
          v-model="password"
          type="password"
          class="form-control"
          placeholder="Password"
          required
        />
      </div>

      <input
        id="flexCheckChecked"
        v-model="isAdmin"
        class="form-check-input me-2 mb-3"
        role="button"
        type="checkbox"
        value=""
      />
      <label class="form-check-label" role="button" for="flexCheckChecked">
        Assign as administrator
      </label>

      <div class="col-3 d-flex justify-content-between">
        <button type="submit" class="btn btn-primary fw-bold">Add User</button>
        <button
          type="button"
          class="btn btn-outline-primary fw-bold"
          @click="selectUserTable"
        >
          Back to Users
        </button>
      </div>
    </form>
  </div>
</template>

<script lang="ts">
import { createUser } from '@/common/api';
import { defineComponent, PropType } from 'vue';
import { handleError } from '@/common/errors';

export default defineComponent({
  name: 'AdminAddNewUser',

  props: {
    selectUserTable: {
      type: Function as PropType<() => void>,
      required: true,
    },
  },

  data() {
    return {
      email: '',
      password: '',
      firstName: '',
      lastName: '',
      isAdmin: false,
      error: null,
    };
  },

  methods: {
    async createUserRequest() {
      try {
        await createUser(
          this.email,
          this.password,
          this.firstName,
          this.lastName,
          this.isAdmin,
        );
        this.selectUserTable();
      } catch (error: unknown) {
        handleError(error, 'Failed to create user');
      }
    },
  },
});
</script>
